// VERSIONE COMPLETA: UI NUOVA + FUNZIONALITÀ ORIGINALI RIPRISTINATE

import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import Navbar from "@/components/layout/Navbar"
import MainLayout from "@/components/layout/MainLayout"
import { supabase } from "@/lib/supabase"
import { useAdmin } from "@/lib/useAdmin"
import { Sparkles, User, Zap, PenTool, Hand, Droplets } from "lucide-react"
import Cropper from "react-easy-crop"

export default function TrattamentiPage() {

  const [trattamenti, setTrattamenti] = useState<any[]>([])

  const [editItem, setEditItem] = useState<any | null>(null)
  const [addOpen, setAddOpen] = useState(false)

  const [categoria, setCategoria] = useState("latest")
  const [sottoCategoria, setSottoCategoria] = useState("tutte")
  const [openDropdown, setOpenDropdown] = useState<string | null>(null)
  const [search, setSearch] = useState("")
  const [categoriaRefs, setCategoriaRefs] = useState<{[key: string]: HTMLDivElement | null}>({})
  const [activeCard, setActiveCard] = useState<number | null>(null)
  const [touchedCard, setTouchedCard] = useState<number | null>(null)
  const [isTouchDevice, setIsTouchDevice] = useState(false)

  const [imageSrc, setImageSrc] = useState<string | null>(null)
  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [zoom, setZoom] = useState(1)
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null)

  const [newItem, setNewItem] = useState({
    nome: "",
    durata: "",
    prezzo: "",
    descrizione_breve: "",
    descrizione: "",
    categoria: "",
    sottocategoria: "",
    best_seller: false
  })

  const isAdmin = useAdmin()
  const navigate = useNavigate()

  const handleLogout = async () => {
    await supabase.auth.signOut()
    localStorage.removeItem("isAdmin")
    window.location.href = "/trattamenti"
  }

  const categorie = [
    { id: "latest", label: "Latest", icon: Sparkles },
    { id: "viso", label: "Viso", icon: User },
    { id: "corpo", label: "Corpo", icon: Sparkles },
    { id: "laser", label: "Laser", icon: Zap },
    { id: "pmu", label: "PMU", icon: PenTool },
    { id: "nails", label: "Nails", icon: Hand },
    { id: "cococera", label: "Cococera", icon: Droplets }
  ]

  const sottoCategorieMap: any = {
    viso: ["needling", "microneedling", "pulizia viso", "tecnologie", "altro"],
    corpo: ["massaggi", "tecnologie", "trattamenti", "altro"],
    laser: ["uomo", "donna", "altro"],
    pmu: ["sopracciglia", "labbra", "eyeliner", "correttivo", "altro"],
    nails: ["manicure", "pedicure", "semipermanente", "ricostruzione", "extreme"],
    cococera: ["cococera", "cera classica", "cera uomo"]
  }

  useEffect(() => {
    const fetchData = async () => {
      const { data } = await supabase.from("trattamenti").select("*").order("created_at", { ascending: false })
      if (data) setTrattamenti(data)
    }
    fetchData()

    const touchDetected =
      'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      ("msMaxTouchPoints" in navigator && (navigator as any).msMaxTouchPoints > 0)
    setIsTouchDevice(touchDetected)
  }, [])

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as HTMLElement
      if (!target.closest('.dropdown-container') && !target.closest('.subcategory-dropdown')) {
        setOpenDropdown(null)
      }
    }

    document.addEventListener('click', handleClickOutside)
    return () => document.removeEventListener('click', handleClickOutside)
  }, [])

  const trattamentiFiltrati = trattamenti
    .filter(t => {
      const matchCategoria = categoria === "latest" || t.categoria === categoria

      const matchSottoCategoria =
        !sottoCategoria ||
        sottoCategoria === "tutte" ||
        t.sottocategoria === sottoCategoria

      const matchSearch = t.nome.toLowerCase().includes(search.toLowerCase())

      return matchCategoria && matchSottoCategoria && matchSearch
    })
    .sort((a, b) => {
      if (categoria === "latest") {
        if (a.best_seller && !b.best_seller) return -1
        if (!a.best_seller && b.best_seller) return 1
      }
      return 0
    })

  const onSelectFile = (e: any) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader()
      reader.addEventListener("load", () => setImageSrc(reader.result as string))
      reader.readAsDataURL(e.target.files[0])
    }
  }

  // 🔥 CROP + UPLOAD PERFETTO
const getCroppedImg = async (imageSrc: string, crop: any) => {
  const image = new Image()
  image.src = imageSrc

  await new Promise((resolve) => {
    image.onload = resolve
  })

  const canvas = document.createElement("canvas")
  const ctx = canvas.getContext("2d")

  canvas.width = crop.width
  canvas.height = crop.height

  ctx?.drawImage(
    image,
    crop.x,
    crop.y,
    crop.width,
    crop.height,
    0,
    0,
    crop.width,
    crop.height
  )

  return new Promise<Blob>((resolve) => {
    canvas.toBlob((blob) => {
      resolve(blob!)
    }, "image/jpeg")
  })
}

const uploadImage = async () => {
  if (!imageSrc || !croppedAreaPixels) return null

  const croppedBlob = await getCroppedImg(imageSrc, croppedAreaPixels)

  const fileName = `${Date.now()}.jpg`

  const { error } = await supabase.storage
    .from("trattamenti")
    .upload(fileName, croppedBlob)

  if (error) {
    alert("Errore upload immagine")
    return null
  }

  const { data } = supabase.storage
    .from("trattamenti")
    .getPublicUrl(fileName)

  return data.publicUrl
}

  const handleAdd = async () => {
    const imageUrl = await uploadImage()

    const { data } = await supabase.from("trattamenti").insert([{
      ...newItem,
      immagine: imageUrl
    }]).select()

    if (data) {
      setTrattamenti(prev => [...data, ...prev])
      setAddOpen(false)
    }
  }

  return (
    <MainLayout>
      <div className="overflow-x-hidden">
        <Navbar />

        {/* HERO */}
        <section className="relative h-[70vh] overflow-hidden">
          <img src="/images/trattamenti/hero-trattamenti.jpg" className="absolute inset-0 w-full h-full object-cover scale-105" />
          <div className="absolute inset-0 bg-black/40" />

          <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center">
            <h1 className="text-5xl md:text-6xl font-serif">I Nostri Trattamenti</h1>
            <p className="text-white/80 mt-3">Tecnologie avanzate e protocolli personalizzati</p>
          </div>
        </section>

        {/* CATEGORIE */}
        <section className="relative z-30 -mt-24 flex justify-center">
          <div className="dropdown-container flex gap-3 px-4 py-3 rounded-full bg-black/40 backdrop-blur-xl border border-white/30 overflow-x-auto scrollbar-hide max-w-full">
            {categorie.map(cat => {
  const Icon = cat.icon

  return (
    <div
      key={cat.id}
      ref={(el) => {
        if (el && !categoriaRefs[cat.id]) {
          setCategoriaRefs(prev => ({ ...prev, [cat.id]: el }))
        }
      }}
      className="relative flex-shrink-0"
    >
      <button
        onClick={() => {
          setCategoria(cat.id)
          setOpenDropdown(openDropdown === cat.id ? null : cat.id)
          setSottoCategoria("tutte")

          // Scroll automatico alla categoria selezionata
          setTimeout(() => {
            const element = categoriaRefs[cat.id]
            if (element) {
              element.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center'
              })
            }
          }, 100)
        }}
        className={`flex items-center gap-2 px-4 py-2 rounded-full whitespace-nowrap transition-all duration-300 ${
          categoria === cat.id
            ? "bg-white/20 text-white font-semibold"
            : "text-white/80 hover:text-white hover:bg-white/10"
        }`}
      >
        <Icon className="w-4 h-4" />
        {cat.label}
      </button>
    </div>
  )
})}
          </div>

          {/* DROPDOWN SOTTOCATEGORIE - FUORI DALLA BARRA */}
          {openDropdown && sottoCategorieMap[openDropdown] && (
            <div className="subcategory-dropdown absolute top-full mt-6 left-1/2 -translate-x-1/2 bg-black/70 backdrop-blur-2xl border border-white/20 rounded-3xl p-4 flex flex-col gap-2 shadow-[0_20px_40px_rgba(0,0,0,0.8)] z-50 min-w-[200px]">
              <button
                onClick={() => {
                  setSottoCategoria("tutte")
                  setOpenDropdown(null)
                }}
                className={`text-sm px-3 py-2 rounded-lg transition ${
                  sottoCategoria === "tutte"
                    ? "bg-white/15 text-white font-semibold backdrop-brightness-125"
                    : "text-white/80 hover:text-white hover:bg-white/20"
                }`}
              >
                Tutte
              </button>

              {sottoCategorieMap[openDropdown].map((sub: string) => (
                <button
                  key={sub}
                  onClick={() => {
                    setSottoCategoria(sub)
                    setOpenDropdown(null)
                  }}
                  className={`text-sm px-3 py-2 rounded-lg transition ${
                    sottoCategoria === sub
                      ? "bg-white/15 text-white font-semibold backdrop-brightness-125"
                      : "text-white/80 hover:text-white hover:bg-white/20"
                  }`}
                >
                  {sub}
                </button>
              ))}
            </div>
          )}
        </section>

        {/* LISTA */}
        <section className="py-20 px-6 bg-[#f8f5f1]">
          <div className="max-w-6xl mx-auto">

            {/* ADMIN BAR */}
            {isAdmin && (
              <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-8">
                <div className="flex items-center gap-3">
                  <button
                    onClick={() => setAddOpen(true)}
                    className="px-5 py-2 rounded-full bg-black text-white hover:scale-105 transition"
                  >
                    + Aggiungi trattamento
                  </button>

                  <button
                    onClick={handleLogout}
                    className="px-5 py-2 rounded-full border border-white/30 text-white hover:bg-black/20 transition"
                  >
                    Logout
                  </button>
                </div>

                <input
                  placeholder="Cerca trattamento..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="w-full md:w-80 px-5 py-3 rounded-full bg-white shadow border border-black/10 focus:outline-none"
                />
              </div>
            )}

            {!isAdmin && (
              <div className="flex justify-center mb-10">
                <input
                  placeholder="Cerca trattamento..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="w-full max-w-md px-5 py-3 rounded-full bg-white shadow border border-black/10 focus:outline-none"
                />
              </div>
            )}

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 md:gap-6 lg:gap-8">
              {trattamentiFiltrati.map(t => (
                <div
                  key={t.id}
                  onClick={(e) => {
                    const target = e.target as HTMLElement
                    if (target.closest('.admin-controls') || target.closest('.best-seller-badge')) return

                    if (isTouchDevice) {
                      if (touchedCard === t.id) {
                        setTouchedCard(null)
                        setActiveCard(null)
                        navigate(`/trattamenti/${t.id}`)
                      } else {
                        setTouchedCard(t.id)
                        setActiveCard(t.id)
                      }
                      return
                    }

                    navigate(`/trattamenti/${t.id}`)
                  }}
                  style={{ backgroundImage: `url(${t.immagine})` }}
                  className="group relative w-full h-52 md:h-[340px] rounded-[36px] bg-cover bg-center overflow-hidden shadow-[0_16px_36px_rgba(0,0,0,0.28)] transition-all duration-500 ease-out hover:-translate-y-2 hover:scale-[1.04] hover:shadow-[0_40px_80px_rgba(0,0,0,0.35)] cursor-pointer border border-white/20 backdrop-blur-xl"
                >
                  <div className="absolute inset-0 bg-black/30" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/20 to-transparent" />

                  {t.best_seller && (
                    <div className="best-seller-badge absolute top-3 right-3 z-20 group">
                      <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-white/20 text-white md:h-8 md:w-8">
                        <span className="text-xs md:text-sm">★</span>
                      </span>
                      <span className="absolute left-1/2 top-full -translate-x-1/2 mt-2 rounded-md bg-black/80 px-2 py-1 text-[11px] text-white opacity-0 transition-opacity duration-200 group-hover:opacity-100">
                        Best Seller
                      </span>
                    </div>
                  )}

                  <div
                    className="relative z-10 flex h-full flex-row md:flex-col justify-between p-3 md:p-6 gap-3"
                    onMouseEnter={() => !isTouchDevice && setActiveCard(t.id)}
                    onMouseLeave={() => !isTouchDevice && setActiveCard(null)}
                  >
                    <div>
                      <h3 className="text-lg md:text-2xl font-bold text-white drop-shadow-lg leading-tight">
                        {t.nome}
                      </h3>
                      <p className="text-xs md:text-sm text-white/90 mt-1">{t.durata}</p>
                    </div>

                    <div className="relative mt-0 md:mt-4 flex-1">
                      <div
                        className={`absolute inset-x-3 bottom-3 md:inset-x-0 md:bottom-0 z-20 p-3 md:p-4 rounded-2xl md:rounded-t-3xl border border-white/30 bg-black/40 bg-clip-padding backdrop-blur-2xl shadow-[inset_0_0_0_1px_rgba(255,255,255,0.4),0_20px_50px_rgba(0,0,0,0.28)] ring-1 ring-white/20 overflow-hidden transition-all duration-300 ${activeCard === t.id ? "translate-y-0 opacity-100" : "translate-y-1/2 opacity-0"}`}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(135deg,rgba(255,255,255,0.45),rgba(255,255,255,0.12)),linear-gradient(180deg,rgba(255,255,255,0.18),rgba(255,255,255,0))]" />
                        <span className="absolute left-2 top-2 w-10 h-1 rounded-full bg-white/30 blur-sm" />
                        <span className="absolute left-1/3 top-6 w-16 h-1 rounded-full bg-white/15 blur-xs" />
                        <div className="relative z-10">
                          <p className="text-left text-[11px] md:text-sm text-white/95 font-semibold leading-relaxed tracking-wide mb-2">
                            {t.descrizione_breve || "Concept d’élite: trattamento couture con ingredienti specialistici, finiture vellutate e glow setoso dall’ispezione professionale."}
                          </p>

                          <button
                            onClick={(e) => {
                              e.stopPropagation()
                              if (isTouchDevice) {
                                if (touchedCard === t.id) {
                                  setTouchedCard(null)
                                  setActiveCard(null)
                                  navigate(`/trattamenti/${t.id}`)
                                } else {
                                  setTouchedCard(t.id)
                                  setActiveCard(t.id)
                                }
                                return
                              }

                              navigate(`/trattamenti/${t.id}`)
                            }}
                            className="inline-flex items-center gap-2 px-3 py-2 rounded-full bg-gradient-to-r from-white/30 to-white/10 border border-white/30 text-[11px] md:text-xs text-white font-semibold tracking-wide backdrop-blur-sm hover:bg-white/30 transition-all duration-200"
                          >
                            Scopri di più
                            <span className="block w-[1px] h-3 bg-white rounded-full" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                    {isAdmin && (
                      <div className="admin-controls absolute bottom-3 left-3 z-30 flex flex-col gap-2 bg-white/80 p-2 rounded-xl backdrop-blur-md border border-white/80 shadow-lg">
                        <button
                          onClick={(e) => {
                            e.stopPropagation()
                            setEditItem(t)
                          }}
                          className="px-3 py-1 bg-white text-black border border-gray-200 rounded-md hover:bg-gray-100 transition"
                        >
                          Modifica
                        </button>

                        <button
                          onClick={async (e) => {
                            e.stopPropagation()
                            await supabase.from("trattamenti").delete().eq("id", t.id)
                            setTrattamenti(prev => prev.filter(x => x.id !== t.id))
                          }}
                          className="px-3 py-1 bg-red-500 text-white rounded-md hover:bg-red-600 transition"
                        >
                          Elimina
                        </button>

                        <button
                          onClick={async (e) => {
                            e.stopPropagation()
                            const updated = !t.best_seller
                            await supabase.from("trattamenti").update({ best_seller: updated }).eq("id", t.id)
                            setTrattamenti(prev => prev.map(x => x.id === t.id ? { ...x, best_seller: updated } : x))
                          }}
                          className="px-3 py-1 bg-yellow-400 text-black rounded-md hover:bg-yellow-500 transition"
                        >
                          ⭐ Best Seller
                        </button>
                      </div>
                    )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {addOpen && (
  <div className="fixed inset-0 bg-black/70 backdrop-blur-[4px] flex items-center justify-center z-50 px-4">

    <div className="bg-white/10 backdrop-blur-xl border border-white/20 p-6 rounded-2xl w-full max-w-md max-h-[90vh] overflow-y-auto">

      <h2 className="text-white text-xl mb-5 text-center">Aggiungi trattamento</h2>

      {/* NOME */}
      <input
        placeholder="Nome"
        value={newItem.nome}
        onChange={(e)=>setNewItem({...newItem,nome:e.target.value})}
        className="w-full mb-3 bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white"
      />

      {/* DURATA */}
      <input
        placeholder="Durata"
        value={newItem.durata}
        onChange={(e)=>setNewItem({...newItem,durata:e.target.value})}
        className="w-full mb-3 bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white"
      />

      {/* PREZZO */}
      <input
        placeholder="Prezzo"
        value={newItem.prezzo}
        onChange={(e)=>setNewItem({...newItem,prezzo:e.target.value})}
        className="w-full mb-3 bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white"
      />

      {/* CATEGORIA */}
      <select
        value={newItem.categoria}
        onChange={(e)=>setNewItem({...newItem,categoria:e.target.value})}
        className="w-full mb-3 bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white"
      >
        <option value="">Categoria</option>
        {categorie.map(c=> (
          <option key={c.id} value={c.id}>{c.label}</option>
        ))}
      </select>

      {/* SOTTOCATEGORIA */}
      <select
        value={newItem.sottocategoria}
        onChange={(e)=>setNewItem({...newItem,sottocategoria:e.target.value})}
        className="w-full mb-3 bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white"
      >
        <option value="">Sottocategoria</option>
        {sottoCategorieMap[newItem.categoria]?.map((sub:string)=>(
          <option key={sub} value={sub}>{sub}</option>
        ))}
      </select>

      {/* DESCRIZIONI */}
      <textarea
        placeholder="Descrizione breve"
        value={newItem.descrizione_breve}
        onChange={(e)=>setNewItem({...newItem,descrizione_breve:e.target.value})}
        className="w-full mb-3 bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white"
      />

      <textarea
        placeholder="Descrizione completa"
        value={newItem.descrizione}
        onChange={(e)=>setNewItem({...newItem,descrizione:e.target.value})}
        className="w-full mb-3 bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white"
      />

      {/* FILE */}
      <input type="file" onChange={onSelectFile} className="w-full mb-3 text-white" />

      {/* CROPPER */}
      {imageSrc && (
        <div className="relative w-full h-64 bg-black rounded-xl overflow-hidden mb-4">
          <Cropper
            image={imageSrc}
            crop={crop}
            zoom={zoom}
            aspect={1}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={(_, area)=>setCroppedAreaPixels(area)}
          />
        </div>
      )}

      {imageSrc && (
        <input
          type="range"
          min={1}
          max={3}
          step={0.1}
          value={zoom}
          onChange={(e)=>setZoom(Number(e.target.value))}
          className="w-full mb-4"
        />
      )}

      {/* BUTTONS */}
      <div className="flex justify-between mt-6">
        <button onClick={()=>setAddOpen(false)} className="px-4 py-2 border border-white/20 rounded-full text-white">
          Annulla
        </button>

        <button onClick={handleAdd} className="px-4 py-2 bg-white/20 text-white rounded-full hover:bg-white/30">
          Salva
        </button>
      </div>

    </div>
  </div>
)}

        {/* EDIT */}
        {editItem && (
  <div className="fixed inset-0 bg-black/70 backdrop-blur-[4px] flex items-center justify-center z-50 px-4 animate-in fade-in duration-200">

    <div className="bg-white/10 backdrop-blur-xl backdrop-saturate-150 border border-white/20 p-6 rounded-2xl w-full max-w-md max-h-[90vh] overflow-y-auto shadow-[0_20px_60px_rgba(0,0,0,0.4)] animate-in zoom-in-95 duration-200">

      <h2 className="text-white text-xl mb-5 text-center">Modifica trattamento</h2>

      {/* NOME */}
      <input
        value={editItem.nome}
        onChange={(e)=>setEditItem({...editItem,nome:e.target.value})}
        className="w-full mb-3 bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white"
      />

      {/* DURATA */}
      <input
        value={editItem.durata}
        onChange={(e)=>setEditItem({...editItem,durata:e.target.value})}
        className="w-full mb-3 bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white"
      />

      {/* PREZZO */}
      <input
        value={editItem.prezzo}
        onChange={(e)=>setEditItem({...editItem,prezzo:e.target.value})}
        className="w-full mb-3 bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white"
      />

      {/* CATEGORIA */}
      <select
        value={editItem.categoria}
        onChange={(e)=>setEditItem({...editItem,categoria:e.target.value})}
        className="w-full mb-3 bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white"
      >
        <option value="">Categoria</option>
        {categorie.map(c=> (
          <option key={c.id} value={c.id}>{c.label}</option>
        ))}
      </select>

      {/* SOTTOCATEGORIA */}
      <select
        value={editItem.sottocategoria || ""}
        onChange={(e)=>setEditItem({...editItem,sottocategoria:e.target.value})}
        className="w-full mb-3 bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white"
      >
        <option value="">Sottocategoria</option>
        {sottoCategorieMap[editItem.categoria]?.map((sub:string)=>(
          <option key={sub} value={sub}>{sub}</option>
        ))}
      </select>

      {/* DESCRIZIONI */}
      <textarea
        value={editItem.descrizione_breve || ""}
        onChange={(e)=>setEditItem({...editItem,descrizione_breve:e.target.value})}
        className="w-full mb-3 bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white"
      />

      <textarea
        value={editItem.descrizione || ""}
        onChange={(e)=>setEditItem({...editItem,descrizione:e.target.value})}
        className="w-full mb-3 bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white"
      />

      {/* FILE + CROP */}
      <input type="file" onChange={onSelectFile} className="w-full mb-3 text-white" />

      {imageSrc && (
        <div className="relative w-full h-64 bg-black rounded-xl overflow-hidden mb-4">
          <Cropper
            image={imageSrc}
            crop={crop}
            zoom={zoom}
            aspect={1}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={(_, area)=>setCroppedAreaPixels(area)}
          />
        </div>
      )}

      {imageSrc && (
        <input
          type="range"
          min={1}
          max={3}
          step={0.1}
          value={zoom}
          onChange={(e)=>setZoom(Number(e.target.value))}
          className="w-full mb-4"
        />
      )}

      {/* BUTTONS */}
      <div className="flex justify-between mt-6">
        <button onClick={()=>{ setEditItem(null); setImageSrc(null) }} className="px-4 py-2 rounded-full border border-white/20 text-white hover:bg-white/10 transition">
          Annulla
        </button>

        <button
          onClick={async () => {
            let imageUrl = editItem.immagine

            if (imageSrc && croppedAreaPixels) {
              const uploaded = await uploadImage()
              if (uploaded) imageUrl = uploaded
            }

            await supabase.from("trattamenti").update({
              ...editItem,
              immagine: imageUrl
            }).eq("id", editItem.id)

            setTrattamenti(prev => prev.map(t => t.id === editItem.id ? { ...editItem, immagine: imageUrl } : t))

            setEditItem(null)
            setImageSrc(null)
          }}
          className="px-4 py-2 rounded-full bg-white/20 text-white hover:bg-white/30 transition"
        >
          Salva
        </button>
      </div>

    </div>
  </div>
)}

      </div>
    </MainLayout>
  )
}
